import {checkCookie} from '../utils/cookies';

function hasUserConsentCookie() {
    return checkCookie('borlabs-cookie');
}

export default function submitUserInfoToEtracker() {
    if (!window.et_eC_Wrapper) {
        return;
    }

    const userConsent = hasUserConsentCookie() ? 'knownUser' : 'unknownUser';
    const seg = hasUserConsentCookie() ? 'et_seg1' : 'et_seg2';

    window.et_eC_Wrapper({et_et: 'userLogin', [seg]: userConsent ? 'bekannt' : 'unbekannt'});
}
